import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2258c185"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "category-month-top-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 0,
  class: "top-win-list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 活动规则 ");
const _hoisted_7 = {
  class: "category-month-btns"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "word"
}, "抽奖记录", -1));
const _hoisted_12 = ["onClick", "src"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["src"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "word"
}, "分享", -1));
const _hoisted_16 = {
  class: "category-month-steps"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_18 = {
  class: "stop-box"
};
const _hoisted_19 = {
  class: "num"
};
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
  class: "category-month-ranking"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "热门众筹", -1));
const _hoisted_23 = {
  class: "rank-list"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "popup"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode("今日抽奖机会已用完"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("明日可继续参与！")], -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "活动期间每天1次抽奖机会，可累计", -1));
const _hoisted_28 = {
  class: "btn-box"
};
const _hoisted_29 = {
  class: "popup"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode("您当前暂无符合条件订单"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("下单即可参与抽奖哦！")], -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "活动期间每天1次抽奖机会，可累计", -1));
const _hoisted_32 = {
  class: "btn-box"
};
const _hoisted_33 = {
  class: "popup popup-no-record"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode("您还没有参与抽奖，快去下单参与"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("免单大奖在前方等你啦")], -1));
const _hoisted_35 = {
  class: "btn-box"
};
const _hoisted_36 = {
  class: "popup-record-list"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "抽奖记录", -1));
const _hoisted_38 = {
  class: "record-list-box"
};
const _hoisted_39 = {
  class: "record-list"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "record-info"
};
const _hoisted_42 = {
  class: "record-title"
};
const _hoisted_43 = {
  key: 0,
  class: "record-des free"
};
const _hoisted_44 = {
  key: 1,
  class: "record-des"
};
const _hoisted_45 = /*#__PURE__*/_createTextVNode("平台补贴 ");
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 元");
const _hoisted_47 = {
  class: "record-status-box"
};
const _hoisted_48 = {
  class: "record-time"
};
import { reactive, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { getCategoryMonthSjw24hRanking, getCategoryMonthDrawRecordList, categoryMonthOpenOrderPrize, getCategoryMonthWinList, getCategoryMonthUserActInfo, getCategoryMonthOrderPrize } from "@api/index";
import { showFailToast } from 'vant';
import { addPositionClick } from "@/utils/sensors-inject.js";
import env from "md-base-tools/env";
import domain from "@/service/domain";
import MDRouter from "@/service/router";
import { useStore } from 'vuex';
import { GoBack, wxMinaShare } from "../../utils/tools";
import CompDanmu from '@@/activity/category-month/category-month-danmu.vue';
import CompPopupChoseOrder from '@@/activity/category-month/popup-chose-order.vue';
import CompProList from '@@/activity/category-month/pro-list.vue';
import CompPopupPrize from "@@/activity/category-month/popup-prize.vue";
import ShareBox from "@@/common/ShareBox.vue";
import CompLottieAnimation from "@@/lottieAnimation.vue";
import CompRankItem from "@@/activity/category-month/rankItem.vue";
export default {
  setup(__props) {
    const route = useRoute();
    const store = useStore();

    // 页面状态
    const state = reactive({
      is_ip: false,
      statusBarH: 10,
      headerHeight: 0,
      qrcodeUrl: '',
      showQrcode: false,
      winList: [],
      steps: ['支持众筹项目<br/>游戏·潮玩', '返回此页面<br/>抽奖赢免单', '众筹成功后<br/>中奖金额原路返回'],
      rankList: [],
      // 热门众筹列表

      active: 0,
      showPopupNoChance: false,
      // 无抽奖机会
      showPopupNoOrder: false,
      // 无订单可参与抽奖
      showPopupNoRecord: false,
      // 无抽奖记录时
      showPopupRecordList: false,
      // 抽奖记录
      recordList: [],
      // 抽奖记录列表
      recordListPage: 1,
      // 抽奖记录页码
      recordListIsNext: true,
      // 是否有下一页
      recordListLoading: false,
      // 抽奖记录加载状态
      recordListFinished: false,
      // 抽奖记录加载完成

      showPopupChoseOrder: false,
      // 选择要抽免单的订单
      showPopupPrize: false,
      // 开奖弹窗
      prizeInfo: {},
      // 订单奖品信息
      categoryMonthproListOffsetTop: 0,
      // tab下的内容置顶的位置，onMounted时计算
      cashbackStatusMap: {
        1: '待返现',
        2: '已返现',
        3: '取消返现'
      },
      isInApp: env.isModianIos() || env.isModianIosNew() || env.isModianAndroid()
    });
    onMounted(() => {
      document.title = "游戏·潮玩品类月";
      state.is_ip = route.query.is_ip == 1 ? true : false;
      const initCategoryMonthproListOffsetTop = () => {
        setTimeout(() => {
          state.categoryMonthproListOffsetTop = Number(categoryMonthpro.value.offsetTop ? categoryMonthpro.value.offsetTop : 0) + Number(state.statusBarH);
        }, 0);
      };

      // 如果是APP端，设置状态栏颜色&获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: '1'
          }
        });

        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "onGetDeviceInfo",
          functionParams: {},
          callBack: e => {
            state.statusBarH = e.data.statusBarH;
            state.headerHeight = window.innerWidth / 750 * 88;
            initCategoryMonthproListOffsetTop();
          }
        });
      } else {
        initCategoryMonthproListOffsetTop();
      }
      getHotList();
      getWinList();
      // 微信小程序分享
      wxMinaShare({
        title: share_des,
        imageUrl: share_5x4,
        url: `${share_url}`
      });
    });

    // 离开页面
    function handleGoBack() {
      GoBack();
    }
    const handleGoRule = () => {
      MDRouter.goCategoryMonthRule();
    };
    // 获取抽奖记录之前
    const getRecordListBefore = () => {
      state.recordList = [];
      getRecordList();
    };
    // 获取抽奖记录
    const getRecordList = () => {
      getCategoryMonthDrawRecordList({
        page: state.recordListPage,
        page_size: 10
      }).then(res => {
        state.recordListLoading = false;
        if (res.status == 0) {
          state.recordList = [...state.recordList, ...(res.data && res.data.list && res.data.list.length ? res.data.list : [])];
          state.recordListIsNext = res.data ? res.data.is_next : false;
          if (state.recordList.length == 0) {
            state.showPopupNoRecord = true;
          } else {
            state.showPopupRecordList = true;
            if (state.recordListIsNext == false) {
              state.recordListFinished = true;
            } else {
              state.recordListPage += 1;
            }
          }
        } else {
          state.recordListFinished = true;
          showFailToast(res.message);
        }
      });
    };
    const onLoadRecord = () => {
      setTimeout(() => {
        if (!state.recordListIsNext) return;
        getRecordList();
      }, 1000);
    };

    // 24小时热度榜
    const getHotList = () => {
      getCategoryMonthSjw24hRanking().then(res => {
        if (res.status == 0) {
          state.rankList = res.data;
        } else {
          showFailToast(res.message);
        }
      });
    };
    // 去详情
    const goToProInfo = (item, index, module) => {
      // 点击打点
      addPositionClick({
        item_id: item.pro_id,
        category: item.category,
        sec_business_line: "101",
        page_source: "品类月",
        module: module,
        module_position: index + 1
      });
      MDRouter.goProInfo(item.pro_id);
    };

    // 去下单
    const goBuy = () => {
      state.showPopupNoOrder = false;
      state.showPopupNoRecord = false;
      categoryMonthIndex.value.scrollTo({
        top: state.categoryMonthproListOffsetTop,
        behavior: "smooth"
      });
    };
    const categoryMonthpro = ref(null);
    const categoryMonthIndex = ref(null);
    // const oldScrollTop = ref(0)
    // const categoryMonthTab = ref(null)
    // 切换tab
    // const changeTab = async (type) => {
    //     state.active = type;
    //     await new Promise(resolve => setTimeout(resolve, 1000))
    //     let nowOffsetTop = categoryMonthIndex.value.scrollTop
    //     // 当前正在吸顶
    //     if (categoryMonthTab.value.offsetTop == 0) {
    //         // 当前存在记录的旧的位置，就跳至旧的位置
    //         if (oldScrollTop.value !== 0) {
    //             categoryMonthIndex.value.scrollTo({
    //                 top: oldScrollTop.value
    //             });
    //             // categoryMonthIndex.value.scrollTop = 500;
    //         } else {
    //             // 不存在记录的旧的位置，就让该TAB下的内容置顶
    //             categoryMonthIndex.value.scrollTo({
    //                 top: state.categoryMonthproListOffsetTop,
    //             });
    //             // categoryMonthIndex.value.scrollTop = 500;
    //         }
    //         oldScrollTop.value = nowOffsetTop
    //     } else {
    //         // 当前未吸顶，就清空记录的旧位置
    //         oldScrollTop.value = 0
    //     }  
    // }

    // 抽免单
    const openDraw = () => {
      getCategoryMonthUserActInfo().then(res => {
        if (res.status == 0) {
          if (res.data == 2) {
            // 无订单
            state.showPopupNoOrder = true;
          } else if (res.data == 1) {
            // 抽奖次数用光
            state.showPopupNoChance = true;
          } else {
            // 正常
            state.showPopupChoseOrder = true;
          }
        } else {
          showFailToast(res.message);
        }
      });
    };
    // 开奖
    const openPrize = item => {
      categoryMonthOpenOrderPrize({
        order_id: item.order_id
      }).then(res => {
        if (res.status == 0 && res.data) {
          state.showPopupPrize = true;
          getPrizeInfo(item.order_id);
        } else {
          showFailToast(res.message);
        }
      });
    };
    const getPrizeInfo = order_id => {
      getCategoryMonthOrderPrize({
        order_id: order_id
      }).then(res => {
        if (res.status == 0) {
          state.prizeInfo = res.data;
        } else {
          state.prizeInfo = {};
        }
      });
    };

    // 分享信息
    const share_1x1 = "https://p6.moimg.net/mdwxapp/category_month_202508/index_mina_share_icon.png?x-oss-process=image/resize,w_350,h_350,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const share_5x4 = "https://p6.moimg.net/mdwxapp/category_month_202508/index_wx_share_icon.png?x-oss-process=image/resize,w_600,h_480,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const share_des = '快来跟我一起抽免单，100%中奖啦';
    const share_url = `${domain.wap}/mdactivity/fastsell/category_month_index`;
    const shareInfo = {
      active_title: "",
      img: share_1x1,
      mina_app_name: "gh_7210ac3f1f08",
      mina_share_img: share_5x4,
      mina_share_path: `pages/webviewPages/content/content?url=${domain.wap}/mdactivity/fastsell/category_month_index`,
      msg_des: share_des,
      qq_des: "",
      qq_share_url: share_url,
      qq_title: share_des,
      qr_img: share_1x1,
      qzone_share_url: share_url,
      share_url: share_url,
      sharelink_url: share_url,
      small_code: "",
      weibo_des: share_url + `${domain.wap}/mdactivity/fastsell/category_month_index` + '（分享自@摩点）',
      weibo_share_url: share_url,
      weibo_title: "",
      weixin_share_url: share_url,
      wxTimeline_share_url: share_url,
      wx_des: "",
      wx_title: share_des
    };
    // 分享
    function handleShareAction() {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'openShareTool',
          functionParams: JSON.parse(JSON.stringify(shareInfo))
        });
      } else {
        triggerChangeShareStatus();
      }
    }
    // 调用 mutation 触发分享
    const triggerChangeShareStatus = () => {
      store.commit('currentShareUpdate', {
        obj: 'share_info',
        value: shareInfo
      });
      store.commit('changeShareStatus', {
        obj: 'showShare'
      });
    };

    // 获取首页中奖用户滚动信息
    const getWinList = () => {
      getCategoryMonthWinList({}).then(res => {
        if (res.status == 0) {
          state.winList = res.data || [];
        } else {
          showFailToast(res.message);
        }
      });
    };

    // tab吸顶
    const isProFix = ref(0);
    const handleStickyActionPro = obj => {
      if (categoryMonthIndex.value.scrollTop >= categoryMonthpro.value.offsetTop) {
        isFix.value = true;
      } else {
        isFix.value = false;
      }
      isProFix.value = obj.isFixed;
    };
    const isFix = ref(0);

    // 去订单详情
    const goOrderInfo = order_id => {
      MDRouter.goProOrderDetail(order_id);
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", {
        class: "category-month-index",
        ref_key: "categoryMonthIndex",
        ref: categoryMonthIndex
      }, [_createElementVNode("header", {
        class: _normalizeClass([{
          'headerAndroid': _unref(env).isModianAndroid(),
          'isProFix': isProFix.value
        }]),
        style: _normalizeStyle({
          'padding-top': _unref(state).statusBarH + 'px'
        })
      }, [_unref(state).isInApp && !_unref(state).is_ip ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        class: "back-icon",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_back.png', 56),
        onClick: _withModifiers(handleGoBack, ["stop"])
      }, null, 8, ["src", "onClick"])) : _createCommentVNode("", true)], 6), _createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        style: {
          "position": "absolute",
          "left": "0",
          "top": "0"
        },
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_index_01.png', 750)
      }, null, 8, _hoisted_2), _createVNode(CompLottieAnimation, {
        jsonUrl: "https://p6.moimg.net/mdwxapp/category_month_202508/category_month_index_lottie.json",
        loop: true
      }), _createElementVNode("img", {
        class: "top-time",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_index_02.png', 480)
      }, null, 8, _hoisted_3), _unref(state).winList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(CompDanmu, {
        items: _unref(state).winList
      }, null, 8, ["items"])])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "share-info",
        style: _normalizeStyle({
          top: _unref(state).statusBarH + 'px'
        }),
        onClick: _withModifiers(handleGoRule, ["stop"])
      }, [_createVNode(_component_van_image, {
        class: "icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_rule.png', 28)
      }, null, 8, ["src"]), _hoisted_6], 12, _hoisted_5)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        class: "btn-bg",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/hdpic01.png', 750)
      }, null, 8, _hoisted_8), _createElementVNode("div", {
        class: "btn draw-record",
        onClick: _withModifiers(getRecordListBefore, ["stop"])
      }, [_createElementVNode("img", {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_index_btn_draw_record.png', 110)
      }, null, 8, _hoisted_10), _hoisted_11], 8, _hoisted_9), _createElementVNode("img", {
        onClick: _withModifiers(openDraw, ["stop"]),
        class: "draw-btn",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_index_btn_draw.png', 370)
      }, null, 8, _hoisted_12), _createElementVNode("div", {
        class: "btn share",
        onClick: _withModifiers(handleShareAction, ["stop"])
      }, [_createElementVNode("img", {
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month_202508/category_month_index_btn_share.png', 110)
      }, null, 8, _hoisted_14), _hoisted_15], 8, _hoisted_13)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).steps, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "step",
          key: index
        }, [_createElementVNode("div", _hoisted_19, _toDisplayString(index + 1), 1), _createElementVNode("div", {
          class: "cont",
          innerHTML: item
        }, null, 8, _hoisted_20)]);
      }), 128))])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).rankList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "rank-item",
          key: index,
          onClick: $event => goToProInfo(item, index, '热门众筹')
        }, [_createVNode(CompRankItem, {
          item: item,
          index: index + 1
        }, null, 8, ["item", "index"])], 8, _hoisted_24);
      }), 128))])]), _createVNode(_component_van_sticky, null, {
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "categoryMonthpro",
          ref: categoryMonthpro,
          class: "category-month-pro-before",
          style: _normalizeStyle({
            'height': isFix.value && _unref(state).isInApp ? _unref(state).statusBarH + 'px' : 0
          })
        }, null, 4)]),
        _: 1
      }), _createVNode(_component_van_tabs, {
        ref: "categoryMonthTab",
        class: "category-month-pro",
        active: _unref(state).active,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => _unref(state).active = $event),
        "lazy-render": false,
        sticky: "",
        background: "#2C009B",
        "offset-top": _unref(state).isInApp ? _unref(state).statusBarH + 'px' : 0,
        onScroll: handleStickyActionPro
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: "在线项目",
          "title-class": "category-month-pro-tab"
        }, {
          default: _withCtx(() => [_createVNode(CompProList, {
            type: "1",
            onGoToProInfo: goToProInfo
          })]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "即将众筹",
          "title-class": "category-month-pro-tab"
        }, {
          default: _withCtx(() => [_createVNode(CompProList, {
            type: "2",
            onGoToProInfo: goToProInfo
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["active", "offset-top"]), _createVNode(_component_van_popup, {
        class: "category-month-popup",
        show: _unref(state).showPopupNoChance,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => _unref(state).showPopupNoChance = $event),
        round: "",
        "close-on-click-overlay": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_hoisted_26, _hoisted_27, _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
          class: "btn ok",
          onClick: _cache[1] || (_cache[1] = $event => _unref(state).showPopupNoChance = false)
        }, "知道了")])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        class: "category-month-popup",
        show: _unref(state).showPopupNoOrder,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => _unref(state).showPopupNoOrder = $event),
        round: "",
        "close-on-click-overlay": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_hoisted_30, _hoisted_31, _createElementVNode("div", _hoisted_32, [_createElementVNode("div", {
          class: "btn cancel",
          onClick: _cache[3] || (_cache[3] = $event => _unref(state).showPopupNoOrder = false)
        }, "知道了"), _createElementVNode("div", {
          class: "btn ok",
          onClick: goBuy
        }, "去下单")])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        class: "category-month-popup",
        show: _unref(state).showPopupNoRecord,
        "onUpdate:show": _cache[6] || (_cache[6] = $event => _unref(state).showPopupNoRecord = $event),
        round: "",
        "close-on-click-overlay": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
          class: "btn cancel",
          onClick: _cache[5] || (_cache[5] = $event => _unref(state).showPopupNoRecord = false)
        }, "知道了"), _createElementVNode("div", {
          class: "btn ok",
          onClick: goBuy
        }, "去下单")])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        class: "category-month-popup category-month-popup-record-list",
        show: _unref(state).showPopupRecordList,
        "onUpdate:show": _cache[9] || (_cache[9] = $event => _unref(state).showPopupRecordList = $event),
        round: "",
        "close-on-click-overlay": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createElementVNode("i", {
          class: "close",
          onClick: _cache[7] || (_cache[7] = $event => _unref(state).showPopupRecordList = false)
        }), _hoisted_37, _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createVNode(_component_van_list, {
          loading: _unref(state).recordListLoading,
          "onUpdate:loading": _cache[8] || (_cache[8] = $event => _unref(state).recordListLoading = $event),
          finished: _unref(state).recordListFinished,
          onLoad: onLoadRecord
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).recordList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "record-item",
              key: index,
              onClick: $event => goOrderInfo(item.order_id)
            }, [_createVNode(_component_van_image, {
              class: "icon",
              src: _ctx.$imgUrlFilter(item.reward_img, 100)
            }, null, 8, ["src"]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(item.reward_title), 1), item.is_free ? (_openBlock(), _createElementBlock("div", _hoisted_43, "免单")) : (_openBlock(), _createElementBlock("div", _hoisted_44, [_hoisted_45, _createElementVNode("strong", null, _toDisplayString(item.cashback_amount), 1), _hoisted_46]))]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(item.ctime), 1), _createElementVNode("div", {
              class: _normalizeClass(['record-status', `record-status${item.cashback_status}`])
            }, _toDisplayString(_unref(state).cashbackStatusMap[item.cashback_status]), 3)])], 8, _hoisted_40);
          }), 128))]),
          _: 1
        }, 8, ["loading", "finished"])])])])]),
        _: 1
      }, 8, ["show"]), _createVNode(CompPopupChoseOrder, {
        show: _unref(state).showPopupChoseOrder,
        "onUpdate:show": _cache[10] || (_cache[10] = $event => _unref(state).showPopupChoseOrder = $event),
        onSub: openPrize
      }, null, 8, ["show"]), _createVNode(CompPopupPrize, {
        show: _unref(state).showPopupPrize,
        "onUpdate:show": _cache[11] || (_cache[11] = $event => _unref(state).showPopupPrize = $event),
        prizeInfo: _unref(state).prizeInfo,
        onHandleShareAction: handleShareAction,
        onOpenDraw: openDraw
      }, null, 8, ["show", "prizeInfo"]), _createVNode(ShareBox)], 512);
    };
  }
};